<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="datetime" label="下单时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					<c-form-item type="input" label="商品规格" name="product_sku_spec"></c-form-item>
					<!--
										<c-form-item type="select" label="状态" name="state" :options="state" ></c-form-item>
					-->
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="订单号"
					name="order_number"
					width="150"
				></c-table-column>

				<c-table-column
					label="下单用户"
					name="nick_name"
					width="150"
				>
					<template v-slot="{data}">
						<span>{{data.nick_name}}</span>
						<span v-if="data.user_manage_mobilephone">({{data.user_manage_mobilephone}})</span>
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.state==1" style="color:darkgreen">正常</span>
						<span v-if="data.state==2" style="color:brown">订单退款</span>
						<span v-if="data.state==3" style="color:darkgray">订单退货</span>
						<span v-if="data.state==4" style="color:red">清单取消</span>
					</template>
				</c-table-column>

				<c-table-column
					label="商品名称"
					name="product_name"
					width="150"
				></c-table-column>

				<c-table-column
					label="商品规格"
					name="product_sku_spec"
					width="100"
				></c-table-column>

				<c-table-column
					label="商品数量"
					name="product_count"
					width="80"
				></c-table-column>

				<c-table-column
					label="补贴类型"
					name="order_type"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.type==1">优惠券</span>
					</template>
				</c-table-column>

				<c-table-column
					label="补贴金额"
					name="money"
					width="100"
				>
					<template v-slot="{data}">
					    {{'¥'+parseFloat(data.money).toFixed(2)}}
						<span v-if="data.cancel_money >0 && data.state != 4" style="color: darkgray">(已取消 {{'¥'+parseFloat(data.cancel_money).toFixed(2)}})</span>
					</template>
				</c-table-column>

				<c-table-column
					label="下单时间"
					name="create_date"
					width="150"
				></c-table-column>

				<c-table-column
					label="备注"
					name="remark"
					width="250"
				></c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/subsidy/detail/${data.id}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_order_settlement',
		
		components: {
			stationedSelector
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		data() {
			return {
				state: [{
					name: '正常',
					value: 1
				},{
					name: '部分结算',
					value: 2
				},{
					name: '全部结算',
					value: 3
				},{
					name: '取消结算',
					value: 4
				}]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/subsidy/record/list',
					data
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>